import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AiInterviewRole, CreateRolePayload, CreateRoleResponse } from '@edtech-ui/core/models/ai-interview/getroles';
import { AiInterviewServiceService } from '@edtech-ui/core/services/ai-interview-service/ai-interview-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-role-create-dailog',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './role-create-dailog.component.html',
  styleUrl: './role-create-dailog.component.scss'
})
export class RoleCreateDailogComponent {
  @Input() show = false;
  @Output() close = new EventEmitter<void>();
  @Output() roleCreated = new EventEmitter<AiInterviewRole>();

  newRoleName = '';
  description = '';
  isSaving = false;

  constructor(
    private toast: ToastrService,
    private aiInterviewService: AiInterviewServiceService
  ) { }

  onClose() {
    this.close.emit();
  }

  onSave() {
    const title = this.newRoleName.trim();
    const description = this.description.trim();

    if (!title) {
      this.toast.warning('Please enter a role title.');
      return;
    }

    const payload: CreateRolePayload = { title, description };
    this.isSaving = true;

    this.aiInterviewService.createRole(payload).subscribe({
      next: (res: CreateRoleResponse) => {
        this.isSaving = false;

        if (res?.Success && res?.Data) {
          this.toast.success(res.Message || 'Role created successfully.');
          this.roleCreated.emit(res.Data); // emit created role object
          this.onClose();
        } else {
          this.toast.warning(res?.Message || 'Unable to create role.');
        }
      },
      error: (err) => {
        this.isSaving = false;
        this.toast.error('Failed to create role. Please try again.');
      }
    });
  }
}
